import application from 'application/application';

const controller = 'DefaultModalSendEmailController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$element',
	'$timeout',
	'notification',
	'$http',
	'helper',
	'API',
	'$stateParams',
	(
		$scope,
		$rootScope,
		$element,
		$timeout,
		notification,
		$http,
		helper,
		API,
		$stateParams
	) => {
		$rootScope.configSendEmail = {
			ids: [],
			emails: [],
			route: '',
			action: undefined,
			title: 'Enviar por email',
			calcelModaLidos: false
		};

		$scope.redirectRoutes = item => {
			$scope.sendGenericEmail(item);
		};

		$scope.clearEmailErrors = function() {
			$scope.invalidEmails = [];
			$scope.duplicateEmails = [];
		};

		$scope.closeModal = () => {
			$('#modalSendEmailComponent').modal('hide');
		};

		$scope.validateEmails = function() {
			if (!$scope.email) {
				$scope.clearEmailErrors();

				return;
			}

			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			// Filtra elementos vazios antes de validar
			const emails = $scope.email
				.split(';')
				.map(e => e.trim())
				.filter(e => e !== '');

			// Validação de e-mails inválidos
			$scope.invalidEmails = emails.filter(e => !emailRegex.test(e));

			// Validação de e-mails duplicados
			const emailSet = new Set();

			$scope.duplicateEmails = emails.filter(e => {
				if (emailSet.has(e)) return true;
				emailSet.add(e);

				return false;
			});
		};

		// Função para adicionar foco no input
		function focusInput() {
			$timeout(() => {
				document.getElementById('inputEmailText').focus();
			}, 0);
		}

		//  Gera o payload para envio de dados de email com base na rota configurada
		//  no objeto $rootScope.configSendEmail.
		$scope.getPayload = emails => {
			let data;

			switch ($rootScope.configSendEmail.route) {
				case 'parcelas': {
					// Desestruturação para obter os dados específicos de parcelas
					const {
						idParcelaFinanceiro,
						categoriaFinanceiro: {
							tipoCategoriaFinanceiro: { idTipoCategoriaFinanceiro }
						}
					} = $rootScope.configSendEmail.action;

					$scope.idTipoCategoriaFinanceiro = idTipoCategoriaFinanceiro;

					data = {
						destinatarios: emails,
						idParcela: idParcelaFinanceiro
					};
					break;
				}

				case 'contato': {
					// Gerar lista de IDs de clientes (pode ser array ou único objeto)
					const idsPessoaCliente = Array.isArray(
						$rootScope.configSendEmail.action
					)
						? $rootScope.configSendEmail.action.map(
								item => item.idPessoaCliente
						  )
						: [$rootScope.configSendEmail.action.idPessoaCliente];

					data = {
						destinatarios: emails,
						idPessoaCliente: idsPessoaCliente
					};
					break;
				}

				case 'subpoena': {
					// Construir string com IDs de movimentos
					const idsMovimentos = Array.isArray($rootScope.configSendEmail.action)
						? $rootScope.configSendEmail.action
								.map(item => String(item.idMovProcessoCliente))
								.join(',')
						: String($rootScope.configSendEmail.action[0].idMovProcessoCliente);

					data = {
						idsMovimentos,
						destinatarios: emails,
						idGrupoMovimento:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: undefined
					};
					break;
				}

				case 'movements': {
					let idsMovimentos = '';

					if ($rootScope.configSendEmail.action.length > 1) {
						let idMovProcessoCliente = [];

						for (
							let index = 0;
							index < $rootScope.configSendEmail.action.length;
							index++
						) {
							idMovProcessoCliente.push(
								String(
									$rootScope.configSendEmail.action[index].idMovProcessoCliente
								)
							);

							idsMovimentos = idMovProcessoCliente.join(', ');
						}
					} else {
						idsMovimentos =
							$rootScope.configSendEmail.action.idMovProcessoCliente;
					}

					data = {
						idsMovimentos,
						destinatarios: emails,
						idGrupoMovimento:
							$scope.groupUserSelected && $scope.groupData
								? $scope.groupData.idGrupo
								: undefined
					};
					break;
				}

				case 'prazos': {
					if (
						$rootScope.configSendEmail.action.idsMovimentosProcesso.length > 0
					) {
						if (
							$rootScope.configSendEmail.action.idsMovimentosProcesso[0]
								.idTipoMovProcesso == -2
						) {
							data = {
								destinatarios: emails,
								idEventoAgenda: $rootScope.configSendEmail.action.id,
								idPublicacao:
									$rootScope.configSendEmail.action.idsMovimentosProcesso[0]
										.idMovimentosProcesso
							};
						} else {
							const action = $rootScope.configSendEmail.action;
							const hasIntimation = action.idsMovimentosProcesso.some(
								mov => mov.idTipoMovProcesso == -3
							);

							data = {
								destinatarios: emails,
								idEventoAgenda: action.id,
								idAndamento:
									action.idsMovimentosProcesso[0].idMovimentosProcesso
							};

							if (hasIntimation) {
								data.idIntimacao = data.idAndamento;
								delete data.idAndamento;
							}
						}
					} else {
						data = {
							destinatarios: emails,
							idEventoAgenda: $rootScope.configSendEmail.action.id
						};
					}
					break;
				}

				case 'cashFlowYear': {
					data = $rootScope.configSendEmail.action;
					data.destinatarios = emails;

					break;
				}

				case 'cashFlow': {
					data = $rootScope.configSendEmail.action;
					data.destinatarios = emails;
					break;
				}

				default:
					console.warn(
						'Rota desconhecida em configSendEmail:',
						$rootScope.configSendEmail.route
					);
					break;
			}

			return data;
		};

		//   Retorna a mensagem de feedback com base no tipo de operação (sucesso/erro)
		//   e na rota configurada no objeto $rootScope.configSendEmail.
		$scope.getMessageFeedback = type => {
			let message;
			const route = $rootScope.configSendEmail.route;

			switch (route) {
				case 'parcelas': {
					const financeType =
						$scope.idTipoCategoriaFinanceiro === -1 ? 'Receita' : 'Despesa';

					message = `${financeType} ${
						type === 'error' ? 'não ' : ''
					}enviada por email!`;
					break;
				}

				case 'contato': {
					message = `Dados ${
						type === 'error' ? 'não ' : ''
					}enviados por email!`;
					break;
				}

				case 'subpoena': {
					const intimationType =
						$rootScope.configSendEmail.action.length > 1
							? 'Intimações'
							: 'Intimação';
					const pluralSuffix =
						$rootScope.configSendEmail.action.length > 1 ? 's' : '';

					message =
						type === 'error'
							? `${intimationType} não enviada${pluralSuffix} por email!`
							: `${intimationType} enviada${pluralSuffix} por email!`;
					break;
				}

				case 'movements': {
					let types = [
						{
							name: 'Andamento',
							idType: -1,
							plural: 'Movimentações'
						},
						{
							name: 'Publicação',
							idType: -2,
							plural: 'Movimentações'
						},
						{
							name: 'Aviso de intimação',
							idType: -3,
							plural: 'Movimentações'
						},
						{
							name: 'Processo INSS',
							idType: -4,
							plural: 'Movimentações'
						},
						{
							name: 'Movimento',
							idType: -5,
							plural: 'Movimentações'
						}
					];

					function getIdType() {
						if (
							Array.isArray($rootScope.configSendEmail.action) &&
							$rootScope.configSendEmail.action[0].movimento &&
							$rootScope.configSendEmail.action[0].movimento.idTipoMovProcesso
						)
							return $rootScope.configSendEmail.action[0].movimento
								.idTipoMovProcesso;

						if ($stateParams.type == 'andamento') return -1;

						if ($stateParams.type == 'publicacao') return -2;

						if (
							$rootScope.configSendEmail.action.movimento &&
							$rootScope.configSendEmail.action.movimento.idTipoMovProcesso
						)
							return $rootScope.configSendEmail.action.movimento
								.idTipoMovProcesso;

						return -5;
					}

					let idTipoAndamentoProcesso = getIdType();

					// Busca um tipo correspondente ao idTipoMovimentoProcesso
					const matchedType = types.find(
						t => t.idType === idTipoAndamentoProcesso
					);

					// Define a nomenclatura correta
					const intimationType =
						$rootScope.configSendEmail.action.length > 1
							? matchedType.plural
							: matchedType.name;

					const pluralSuffix =
						$rootScope.configSendEmail.action.length > 1 ? 's' : '';
					let envi =
						idTipoAndamentoProcesso == -5 ||
						(!($rootScope.configSendEmail.action.length > 1) &&
							idTipoAndamentoProcesso == -1)
							? 'enviado'
							: 'enviada';

					if (
						$rootScope.configSendEmail.action.length > 1 &&
						idTipoAndamentoProcesso == -5
					)
						envi = 'enviada';

					message =
						type === 'error'
							? `${intimationType} não ${envi}${pluralSuffix} por email!`
							: `${intimationType} ${envi}${pluralSuffix} por email!`;

					break;
				}

				case 'prazos': {
					const idTipoEventoAgenda =
						$rootScope.configSendEmail.action.idTipoEventoAgenda;

					const nameType =
						idTipoEventoAgenda == -3
							? 'Compromisso'
							: idTipoEventoAgenda == -1
							? 'Tarefa'
							: 'Prazo';

					message =
						type === 'error'
							? `${nameType} não enviad${
									idTipoEventoAgenda == -1 ? 'a' : 'o'
							  } por email.`
							: `${nameType} enviad${
									idTipoEventoAgenda == -1 ? 'a' : 'o'
							  } por email!`;
					break;
				}

				case 'cashFlowYear': {
					message =
						type === 'error'
							? 'Fluxo de caixa não enviado por email.'
							: 'Fluxo de caixa enviado por email!';
					break;
				}

				case 'cashFlow': {
					message =
						type === 'error'
							? 'Fluxo de caixa não enviado por email.'
							: 'Fluxo de caixa enviado por email!';
					break;
				}

				default:
					console.warn('Rota desconhecida em configSendEmail:', route);

					message = 'Operação desconhecida!';
					break;
			}

			return message;
		};

		$scope.sendGenericEmail = function(email) {
			if ($scope.printing) return false;
			$scope.invalidEmails = [];
			$scope.duplicateEmails = [];

			if (!email) {
				$scope.invalidEmails.push('Campo de email vazio');
				focusInput(); // Foco no input

				return;
			}

			let emails = email.split(';').map(e => e.trim());

			// Filtrar os elementos não vazios
			emails = emails.filter(email => email.trim() !== '');
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			// Validação de emails inválidos
			$scope.invalidEmails = emails.filter(e => !emailRegex.test(e));

			// Validação de emails duplicados
			const emailSet = new Set();

			$scope.duplicateEmails = emails.filter(e => {
				if (emailSet.has(e)) return true;
				emailSet.add(e);

				return false;
			});

			if ($scope.invalidEmails.length || $scope.duplicateEmails.length) {
				focusInput(); // Foco no input

				return;
			}

			$scope.printing = true;

			const data = $scope.getPayload(emails);

			$http({
				...helper.http(API.email, $rootScope.configSendEmail.route),
				method: 'POST',
				data,
				messageOverride: {
					success(response, notify) {
						let mensagemSucesso =
							(response &&
								response.data &&
								response.data.status &&
								response.data.status.mensagem) ||
							'Email enviado com sucesso.';

						mensagemSucesso = $scope.getMessageFeedback('success');

						notify.success(mensagemSucesso);

						// Limpa o campo de entrada e validações
						$scope.email = '';
						$scope.$resetFormValidation('sendEmail')();

						// Fecha o modal
						$('#modalSendEmailComponent').modal('hide');

						// Habilita novamente o botão após o delay
						$timeout(() => {
							$scope.disableMail = false;
							$scope.printing = false;

							let movement = $rootScope.configSendEmail.action;

							const hasUnread = Array.isArray(movement)
								? movement.some(item => !item.lido)
								: !movement.lido;

							let modal = $('#modalToggleAsReadDetails').length
								? $('#modalToggleAsReadDetails')
								: $('#modalToggleAsRead');

							modal = modal.length ? modal : $('#modalToggleAsReadLabel');

							if (hasUnread && !$rootScope.configSendEmail.calcelModaLidos)
								modal.modal('show');
						}, 500);
					},
					error(response, notify) {
						// Verifica se a resposta contém erros
						const erros =
							response &&
							response.data &&
							response.data.status &&
							response.data.status.erros;
						let mensagemErro =
							(erros && erros[0] && erros[0].mensagem) ||
							'Erro ao enviar o email.';

						mensagemErro = $scope.getMessageFeedback('error');
						// Notifica o erro
						notify.danger(mensagemErro, data);

						// Reativa o botão de envio em caso de erro
						$scope.disableMail = false;
						$scope.printing = false;
					}
				},
				noCancelOnRouteChange: true
			}).finally(() => {
				// Finaliza o estado de "printing"
				$scope.printing = false;
			});
		};

		$('#modalSendEmailComponent').on('shown.bs.modal', function() {
			$('[data-toggle="tooltip"]').tooltip();
			$('#inputEmailText').focus();

			if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
				$rootScope.$apply();
			}
		});

		$('#modalSendEmailComponent').on('hidden.bs.modal', function() {
			$('[data-toggle="tooltip"]').tooltip('dispose');
			$scope.$resetFormValidation('sendEmail')();
			$scope.clearEmailErrors();
			$scope.clearAll = false;
			$scope.itemChecked = false;
			$scope.email = '';
		});
	}
]);

export default controller;
